<div class="notifications">
    <div *ngFor="let notification of notifications" 
         class="notification" 
         [ngClass]="className(notification)">
		<ng-container 
		     *ngTemplateOutlet="notificationTpl;context:{notification:notification}">
		</ng-container>
	</div>
</div>

<ng-template #notificationTpl let-notification="notification">
	<div class="title" 
	     fxLayoutAlign="space-between center">
	    <div style="width:345px;margin:auto;padding: 10px;">
	        {{notification.title}}
		</div> 
	    <div style="width:100px;padding-left:65px;margin-top:-23px"> 
	        <button mat-icon-button 
	               (click)="close(notification)"
	               matTooltip="Close the notification"
	               matTooltipPosition="before">
	             <mat-icon>disabled_by_default</mat-icon>
	        </button>
	    </div>	
	</div>
	<div class="message" [innerHTML]="notification.message"></div>
</ng-template>
